import { userLanguage, ValidLanguages } from '$translations/index';
import { ErrorMessageEn, ErrorMessageEs } from '../../../../constants/alerts';
import { errorHandler } from '../../../utils';
import {
  CandidateAiScoreBuilder,
  GenerateAiDataInput,
} from '../candidate-ai.types';

export const generateAiData = (builder: CandidateAiScoreBuilder) =>
  builder.mutation<any, GenerateAiDataInput>({
    query: ({ candidateIds }) => ({
      url: `/candidates/ai-score`,
      method: 'POST',
      body: {
        candidateIds,
      },
    }),
    transformErrorResponse: (error: any) => {
      errorHandler(
        '[setEducationalInfoAction]',
        userLanguage === ValidLanguages.es
          ? ErrorMessageEs.GenerateAiScoreError
          : ErrorMessageEn.GenerateAiScoreError,
        error,
        true
      );
      return error;
    },
  });
